"use strict";

angular
  .module("diceApp")
  .factory("CondensedReportTemplate", function (DiceResource) {
    const resource = DiceResource("/condensed-report-templates");

    function copy(template) {
      const copied = angular.copy(template);
      if (!copied) {
        return {};
      }
      copied.names?.forEach(detach);
      copied.memberTypes?.forEach(detach);
      return detach(copied);
    }

    function detach(entity) {
      delete entity.id;
      return entity;
    }

    return _.extend(resource, { copy });
  });
